module.exports = __webpack_public_path__ + "media/img/vca/nomf4-d6f14780e62742d39b8fee6fe8d967f9.png";